<template>
  <div>
    <b-card style="position: relative">
      <div v-if="$store.getters['maintenances.form/isLoading']" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
        <b-row>
          <b-col cols="12">
            <maintenance-form />
          </b-col>
          <b-col cols="12">
            <b-button 
              v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
              v-on:click="() => $store.dispatch('maintenances.form/update')"
              variant="primary" 
              class="mr-1"
            >
              {{ $t('MAINTENANCES_SAVE_LABEL') }}
            </b-button>
          </b-col>
        </b-row>
    </b-card>

    <b-card style="position: relative">
      <div v-if="$store.getters['maintenances.form/isLoading']" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
        <b-row>
          <b-col cols="12">
            <history-card />
          </b-col>
        </b-row>
    </b-card>

  </div>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'

import { 
  BButton, 
  BCard, 
  BCol, 
  BForm, 
  BFormGroup, 
  BFormInput,
  BInputGroup, 
  BRow, 
  BAlert, 
  BTabs, 
  BTab, 
  BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import MaintenanceForm from '../components/form'
import historyCard from '../components/history'
import StoreModule from '@/app/maintenances/form.store.js'

export default {
  name: 'details',
  components: {
    MaintenanceForm,
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    historyCard
  },
  directives: {
    Ripple
  },
  setup( props, { root }) {

    const STORE_MODULE = 'maintenances.form'
    store.registerModule(STORE_MODULE, StoreModule)

    store.commit('maintenances.form/updateRoot', root)

    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE))
          store.unregisterModule(STORE_MODULE)
    })

    store.dispatch('maintenances.form/loadFromRoute')

    return {}

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
